import * as React from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { FLAT_BTN, RAISED_BTN } from '../../lib/constants';
import { ButtonProps } from '@mui/material/Button/Button';

interface Props extends ButtonProps {
  showSpinner: boolean;
  label?: string;
  disabled?: boolean;
  onClick(event);
}

const SubmitButton = ({ showSpinner = false, ...otherProps }: Props) => {
  const spinner = <CircularProgress size={24} thickness={2.5} />;
  return (
    <Button {...otherProps}>
      {showSpinner ? spinner : null}
      {otherProps.label ? otherProps.label : 'Submit'}
    </Button>
  );
};

export default SubmitButton;
